import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text--secondary font-italic"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model) = $event)),
    title: "Ajouter une ligne",
    validDisabled: !_ctx.isValid,
    "previous-display": _ctx.step !== 'default',
    onValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.valid())),
    onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.close())),
    onPrevious: _cache[12] || (_cache[12] = ($event: any) => (_ctx.previous())),
    prefixDataCy: "InvoiceProductsDialog-valid",
    "max-width": "900px"
  }, {
    activator: _withCtx(({ props }) => [
      _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps({ props })))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        style: _normalizeStyle({ width: !_ctx.$vuetify.display.smAndDown ? '40vw' : '80vw' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "default" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "my-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex align-center flex-shrink-0 flex-grow-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.search,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                            label: "Rechercher",
                            outlined: "",
                            "hide-details": "",
                            density: "compact",
                            "append-inner-icon": "$search",
                            clearable: "",
                            "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { class: "d-flex align-center justify-end flex-shrink-1 flex-grow-0 pl-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 'create')),
                            elevation: "0",
                            color: "primary",
                            size: "small",
                            "data-cy": "InvoiceProductsDialog-add"
                          }, {
                            default: _withCtx(() => [
                              _cache[14] || (_cache[14] = _createTextVNode(" Créer ")),
                              _createVNode(_component_v_icon, { right: "" }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("$add")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (!_ctx.loading && _ctx.companyProducts.length)
                    ? (_openBlock(), _createBlock(_component_v_list, {
                        key: 0,
                        style: {"height":"40vh","overflow":"scroll"},
                        lines: "two"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.filtredCompanyProducts.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Aucun resultat trouvé pour la recherche ")
                              ], 64))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtredCompanyProducts, (product, i) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: i,
                              onClick: ($event: any) => (_ctx.selectProduct(product)),
                              class: _normalizeClass(_ctx.getProductClass(product.id)),
                              style: {"background":"#fff"},
                              "data-cy": 'selectInvoiceProduct-product-' + i
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  color: "secondary",
                                  icon: 
                                        product.id === _ctx.selectedProduct.id
                                            ? '$radio_button_checked'
                                            : '$radio_button_unchecked'
                                    
                                }, null, 8, ["icon"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(product.title) + " - " + _toDisplayString(product.reference), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(product.unitPrice) + " € ( " + _toDisplayString(product.vatRate) + " %)", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "class", "data-cy"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (!_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode(" Vous n'avez aucun produit enregistré ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.startNewProduct,
                                  elevation: "0",
                                  color: "primary",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[17] || (_cache[17] = _createTextVNode(" Créer ")),
                                    _createVNode(_component_v_icon, { right: "" }, {
                                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                                        _createTextVNode("$add")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  color: "primary"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.selectedProduct && _ctx.selectedProduct.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.selectedProduct.title) + " - " + _toDisplayString(_ctx.selectedProduct.reference) + " / " + _toDisplayString(_ctx.selectedProduct.unitPrice) + " € ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_2, " Sélectionnez un produit "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            modelValue: _ctx.selectedProduct.unitQuantity,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedProduct.unitQuantity) = $event)),
                            label: "Quantité",
                            outlined: "",
                            dense: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "pl-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            label: "Total",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            "model-value": _ctx.totalAmount
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "create" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "8",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.newProduct.title,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newProduct.title) = $event)),
                            label: "Nom",
                            "hide-details": "",
                            "data-cy": "InvoiceProductsDialog-name",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "pl-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.newProduct.reference,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newProduct.reference) = $event)),
                            label: "Référence",
                            "hide-details": "",
                            "data-cy": "InvoiceProductsDialog-reference",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            modelValue: _ctx.newProduct.unitPrice,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newProduct.unitPrice) = $event)),
                            label: "Prix unitaire",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            "data-cy": "InvoiceProductsDialog-price"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pl-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            modelValue: _ctx.newProduct.vatRate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newProduct.vatRate) = $event)),
                            items: _ctx.vatRates,
                            "item-title": "text",
                            "item-value": "value",
                            "menu-props": { auto: true },
                            label: "Taux de TVA",
                            "data-cy": "zTillReceipt-vatRate",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 3
  }, 8, ["modelValue", "validDisabled", "previous-display"]))
}